var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[(_vm.selectedIconContent)?_c('div',{ref:"iconRef",staticClass:"svgDiv",style:({ width: _vm.width, height: _vm.height }),domProps:{"innerHTML":_vm._s(_vm.selectedIconContent)}}):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }